class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return
    if (!state.sections) return

    if (typeof state.sections['push-cart-count'] !== 'string') return

    const newCartTotal = parseInt(
      this.getCount(state.sections['push-cart-count']),
    )

    const newCountText = this.getCount(state.sections['push-cart-count'])

    this.textContent = newCountText
    this.setAttribute('aria-hidden', newCartTotal === 0)
    
    // Update all elements with data-cart-count attribute
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = newCountText
      el.setAttribute('aria-hidden', newCartTotal === 0)
    })
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}

// Initialize a standalone listener for data-cart-count elements
// This works even if no <cart-count> element exists in the DOM
window.addEventListener('DOMContentLoaded', () => {
  const onCartChanged = (e) => {
    const { state } = e.detail
    if (!state || !state.sections || typeof state.sections['push-cart-count'] !== 'string') return

    const DOM = window.BAO.sectionRenderer.convertToDOM(state.sections['push-cart-count'])
    const newCountText = DOM.querySelector('#push-cart-count').textContent
    const newCartTotal = parseInt(newCountText)

    // Update all elements with data-cart-count attribute
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = newCountText
    })
  }

  window.BAO.eventBus.addEventListener(
    window.BAO.EVENTS.PUSH_CART.CHANGED,
    onCartChanged,
  )
})
